import { ListGroup } from 'react-bootstrap'
import { NotificationModalRowProps } from './types'
import { formatDate, formatTime } from '../../features/notification/utility'
const NotificationRow = ({
    createdOn,
    message,
    title,
    link,
    isSeen,
    id,
    readFunction,
}: NotificationModalRowProps) => {
    return (
        <ListGroup.Item
            className={`d-flex align-items-center pointer ${!isSeen && ' unread-noti-color'}`}
            onClick={() => readFunction(id)}
        >
            <div className="ms-2 me-auto">
                <div className="date">{formatDate(createdOn)}</div>
                <div>
                    <b>{title}</b>
                </div>
                <div className="wrap">{message}</div>
                {link && (
                    <a href={link} target="_blank" rel="noreferrer">
                        {link}
                    </a>
                )}
                <div className="time">{formatTime(createdOn)}</div>
            </div>
            {!isSeen && <div className="unread" />}
        </ListGroup.Item>
    )
}
export default NotificationRow
